import { useTranslations } from '@vocab/react';
import { Alert, Text } from 'braid-design-system';
import type { FC } from 'react';

import translations from './.vocab';
// TODO : Waiting to finalise this message
export const AutoRejectBanner: FC = () => {
  const { t } = useTranslations(translations);
  return (
    <Alert tone="info">
      <Text size="small">
        {t(
          "Based on the job ad preference you selected, we've moved applicants who don't meet your must-have requirements into the Not Suitable folder. We inform applicants they're unlikely to progress when their application has been in this folder for 48 hours.",
        )}
      </Text>
    </Alert>
  );
};
